// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1d4Gt","requiredAsterisk":"Info_requiredAsterisk__c_bJx"};